var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"s-select-widget"},[_c('div',{staticClass:"preview"},[_vm._t("preview")],2),_c('div',{staticClass:"label text-ellipsis"},[_vm._v("\n        "+_vm._s(_vm.label)+"\n    ")])])}
var staticRenderFns = []

export { render, staticRenderFns }